<timepicker
    [(ngModel)]="time"
    [showMeridian]="false"
    [hourStep]="1"
    [minuteStep]="5"
    (ngModelChange)="timeSelectionDone($event)"
>
</timepicker>
